var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameGen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7917 6.125H10.2083C7.9625 6.125 6.125 7.9625 6.125 10.2083V38.7917C6.125 41.0375 7.9625 42.875 10.2083 42.875H38.7917C41.0375 42.875 42.875 41.0375 42.875 38.7917V10.2083C42.875 7.9625 41.0375 6.125 38.7917 6.125ZM38.7917 38.7917H10.2083V10.2083H38.7917V38.7917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 36.75C17.0039 36.75 18.375 35.3789 18.375 33.6875C18.375 31.9961 17.0039 30.625 15.3125 30.625C13.6211 30.625 12.25 31.9961 12.25 33.6875C12.25 35.3789 13.6211 36.75 15.3125 36.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 18.375C17.0039 18.375 18.375 17.0039 18.375 15.3125C18.375 13.6211 17.0039 12.25 15.3125 12.25C13.6211 12.25 12.25 13.6211 12.25 15.3125C12.25 17.0039 13.6211 18.375 15.3125 18.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.5625C26.1914 27.5625 27.5625 26.1914 27.5625 24.5C27.5625 22.8086 26.1914 21.4375 24.5 21.4375C22.8086 21.4375 21.4375 22.8086 21.4375 24.5C21.4375 26.1914 22.8086 27.5625 24.5 27.5625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 36.75C35.3789 36.75 36.75 35.3789 36.75 33.6875C36.75 31.9961 35.3789 30.625 33.6875 30.625C31.9961 30.625 30.625 31.9961 30.625 33.6875C30.625 35.3789 31.9961 36.75 33.6875 36.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 18.375C35.3789 18.375 36.75 17.0039 36.75 15.3125C36.75 13.6211 35.3789 12.25 33.6875 12.25C31.9961 12.25 30.625 13.6211 30.625 15.3125C30.625 17.0039 31.9961 18.375 33.6875 18.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameGen);
export default __webpack_public_path__ + "static/media/nameGen.b7234641d1923f08264d904a36bcceca.svg";
export { ForwardRef as ReactComponent };